export enum Period {
    AllTime = "all-time",
    Last7Days = "last-7-days",
    Last30Days = "last-30-days",
    Last90Days = "last-90-days",
    CustomRange = "custom-range",
}

export const PERIODS = [
    { key: Period.AllTime, value: 1000 },
    { key: Period.Last7Days, value: 7 },
    { key: Period.Last30Days, value: 30 },
    { key: Period.Last90Days, value: 90 },
    { key: Period.CustomRange, value: 0 },
];

export function getStartDate(baseDate: Date, daysAgo: number): string {
    if (!isFinite(daysAgo)) {
        return '1970-01-01 00:00:00';
    }

    const date = new Date(baseDate);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - daysAgo);

    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${year}-${month}-${day} 00:00:00`;
}

export const transformToCurrency = (value: number) => {
    value = value / 4100;
    const result = value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return result;
};
